<template>
  <div>
    <header ref="header" :class="'header-' + variant + ' ishide-' + isHide">
      <div class="header-container">
        <div class="logo">
          <a @click="goToPage('/index')" data-cursor
            ><img src="@/assets/logo.png" alt="logo"
          /></a>
          <div class="logo-title">大學問總管理中心</div>
        </div>

        <div class="top-right">
          <nav class="top-nav" ref="topNav">
            <ul class="no-listStyle">
              <li
                v-for="(item, idx) in filteredMenus"
                :key="idx"
                :id="'m' + item.menuId"
                class="pointer"
              >
                <p
                  class="nav-title flex align-center justify-between"
                  @click="openNav(idx)"
                >
                  <span>{{ item.menuName }}</span>
                  <i
                    :class="[
                      showNav === idx
                        ? 'el-icon-arrow-up'
                        : 'el-icon-arrow-down',
                    ]"
                    style="font-size: 16px"
                  ></i>
                </p>
                <ul
                  class="no-listStyle nav-listStyle-menu"
                  :class="{ show: showNav === idx }"
                >
                  <li
                    v-for="(i, index) in item.children"
                    :key="index"
                    :id="'m' + i.menuId"
                  >
                    <!-- <span
                      v-if="i.children && i.children.length > 0"
                      class="flex align-center justify-between"
                      @click="openNav(`${idx}-${index}`)"
                    >
                      <a style="margin: 0">
                        <img class="nav-icon1" :src="i.icon" />
                        <img class="nav-icon2" :src="i.iconOn" />

                        {{ i.menuName }}
                      </a>
                      <i
                        :class="[
                          showNav.includes(`${idx}-${index}`)
                            ? 'el-icon-arrow-up'
                            : 'el-icon-arrow-down',
                        ]"
                        style="font-size: 14px"
                      ></i>
                    </span> -->
                    <span class="nav-item-title">
                      <a
                        :class="{ on: current(i.adminPath, i.children) }"
                        @click="goToPage(i.adminPath)"
                      >
                        <template v-if="i.adminIcon && i.adminIconActive">
                          <img class="nav-icon1" :src="i.adminIcon" />
                          <img class="nav-icon2" :src="i.adminIconActive" />
                        </template>

                        {{ i.menuName }}
                      </a>
                    </span>
                    <!-- <ul
                      class="no-listStyle nav-item2"
                      :class="{ show: showNav.includes(`${idx}-${index}`) }"
                      v-if="i.children && i.children.length > 0"
                    >
                      <li
                        v-for="(i2, index2) in i.children"
                        :key="index2"
                        :id="'m' + i2.id"
                      >
                        <span>
                          <a
                            :class="{ on: current(i2.outLink, i2.children) }"
                            @click="goToPage(i2.outLink)"
                          >
                            {{ i2.name }}</a
                          >
                        </span>
                      </li>
                    </ul> -->
                  </li>
                </ul>
              </li>
            </ul>

            <div class="header-account" @click="goToPage('/account-info')">
              <div class="account u-flex">
                <img
                  class="avatar"
                  v-if="userInfo.avatar"
                  :src="userInfo.avatar"
                />
                <img class="avatar" v-else src="../assets/d-logo.png" />
                <div>
                  {{ userInfo.nickName }}，您好
                  <i style="margin-left: 0.1rem" class="el-icon-arrow-down"></i>
                </div>
              </div>
            </div>
          </nav>
          <div class="tools flex__aic">
            <div class="openMenu" ref="openMenu" @click="toggleWapMenu">
              <i></i><i></i><i></i>
            </div>
          </div>
        </div>
      </div>
    </header>
    <userLogin ref="userLogin"></userLogin>
  </div>
</template>
<script>
// 1. 导入权限工具
import { initPermissions, filterMenus } from "@/utils/permission.js";
import userLogin from "@/components/userLogin.vue";

export default {
  components: {
    userLogin,
  },
  props: {
    variant: {
      type: String,
      default: "default",
    },
    isHide: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showNav: -1,
      userInfo: {},
      keyword: "",
      searchSelect: 1,
      searchOptions: [
        {
          label: "搜名称",
          value: 1,
        },
        {
          label: "搜编号",
          value: 2,
        },
      ],
      filteredMenus: [],
      rawMenus: [
        {
          title: "招生數據中心",
          children: [
            {
              id: 1,
              name: "招生儀表板",
              isShow: true,
              outLink: "/index",
              icon: require("@/assets/t1.png"),
              iconOn: require("@/assets/t2.png"),
            },
            {
              id: 2,
              name: "人氣趨勢追蹤",
              outLink: "/popularity",

              isShow: true,
              icon: require("@/assets/t3.png"),
              iconOn: require("@/assets/t4.png"),
            },
            // {
            // 	id: 3,
            // 	name: '帳號與個人資料',
            // 	outLink: '/account',
            // 	children: [{
            // 		outLink: '/account-info',
            // 	}],
            // 	icon: require('@/assets/t5.png'),
            // 	iconOn: require('@/assets/t6.png'),
            // },
          ],
        },
        {
          title: "會員管理",
          children: [
            {
              id: "member:archive:query",
              name: "大學會員管理",
              outLink: "/university-user",
              icon: require("@/assets/t5.png"),
              iconOn: require("@/assets/t6.png"),
            },
            {
              id: 5,
              id: "member:accountApply:query",
              name: "加購管理",
              outLink: "/account-add",
              icon: require("@/assets/t5.png"),
              iconOn: require("@/assets/t6.png"),
            },
            {
              id: "member:renewal:query",
              name: "續約管理",
              outLink: "/renewal-add",
              icon: require("@/assets/t5.png"),
              iconOn: require("@/assets/t6.png"),
            },
            // {
            //   id: 4,
            //   name: "個人會員管理",
            //   outLink: "/User",

            //   isShow: true,
            //   icon: require("@/assets/t7.png"),
            //   iconOn: require("@/assets/t7.png"),
            // },
            // {
            //   id: 4,
            //   name: "國際會員管理",
            //   outLink: "",

            //   isShow: true,
            //   icon: require("@/assets/t8.png"),
            //   iconOn: require("@/assets/t8.png"),
            // },
          ],
        },
        {
          title: "權限與資料管理",
          children: [
            {
              id: 1,
              name: "功能權限設定",
              outLink: "",
              icon: require("@/assets/t9.png"),
              iconOn: require("@/assets/t9.png"),
              children: [
                {
                  id: "system:user:query",
                  name: "員工權限",
                  outLink: "/account",
                  icon: require("@/assets/t9.png"),
                  iconOn: require("@/assets/t9.png"),
                },
                {
                  id: "system:role:query",
                  name: "層級管理",
                  outLink: "/role",
                  icon: require("@/assets/t10.png"),
                  iconOn: require("@/assets/t10.png"),
                },
                {
                  id: "system:dept:query",
                  name: "部門管理",
                  outLink: "/department",
                  icon: require("@/assets/t10.png"),
                  iconOn: require("@/assets/t10.png"),
                },
              ],
            },
            {
              id: 1,
              name: "校系資料管理",
              outLink: "",
              icon: require("@/assets/t10.png"),
              iconOn: require("@/assets/t10.png"),
              children: [
                {
                  id: "system:school:query",
                  name: "學校管理",
                  outLink: "/school",
                  icon: require("@/assets/t9.png"),
                  iconOn: require("@/assets/t9.png"),
                },
                {
                  id: "system:schoolDepartment:query",
                  name: "學系管理",
                  outLink: "/college",

                  icon: require("@/assets/t10.png"),
                  iconOn: require("@/assets/t10.png"),
                },
                {
                  id: "system:schoolGroup:query",
                  name: "校系學群",
                  outLink: "/group",
                  icon: require("@/assets/t10.png"),
                  iconOn: require("@/assets/t10.png"),
                },
              ],
            },
            {
              id: 2,
              name: "上稿功能",
              outLink: "",
              isShow: true,
              icon: require("@/assets/t10.png"),
              iconOn: require("@/assets/t10.png"),
              children: [
                {
                  id: "content:ad:list",
                  name: "廣告管理",
                  outLink: "/content/ad",
                },
                {
                  id: "content:articleCategory:list",
                  name: "分類管理",
                  outLink: "/content/article-category",
                },
                {
                  id: "content:article:list",
                  name: "文章管理",
                  outLink: "/content/article",
                },
              ],
            },
          ],
        },
        {
          title: "学生管理",
          children: [
            {
              id: 1,
              name: "学生管理",
              outLink: "/student",
              icon: require("@/assets/xs1.png"),
              iconOn: require("@/assets/xs2.png"),
              children: [],
            },
          ],
        },
        {
          title: "订阅管理",
          children: [
            {
              id: 1,
              name: "套餐定义",
              outLink: "/packageDefinition",
              icon: require("@/assets/tc1.png"),
              iconOn: require("@/assets/tc2.png"),
              children: [],
            },
            {
              id: 2,
              name: "订阅记录",
              outLink: "/subscriptionHistory",
              icon: require("@/assets/dy1.png"),
              iconOn: require("@/assets/dy2.png"),
              children: [],
            },
            {
              id: 3,
              name: "电子发票管理",
              outLink: "/invoiceManagement",
              icon: require("@/assets/fp1.png"),
              iconOn: require("@/assets/fp2.png"),
              children: [],
            },
          ],
        },
        {
          title: "其他设置",
          children: [
            {
              id: 1,
              name: "欢迎语管理",
              outLink: "/welcomeMessage",
              icon: require("@/assets/sz1.png"),
              iconOn: require("@/assets/sz2.png"),
              children: [],
            },
          ],
        },
      ],
      logo: "",
      isDark: false,
      lastScrollTop: 0,
      scrollThreshold: 5,
      scrollDirection: "",
      showLoginBox: false,
      searchBox: false,
      userDropShow: false,
      cartNum: 0,
    };
  },
  mounted() {
    this.showNav = localStorage.getItem("showNav") || -1;
    this.getInfo();
  },
  methods: {
    openNav(idx) {
      this.showNav = idx;

      localStorage.setItem("showNav", idx);
    },
    getInfo() {
      const that = this;
      that.$axios
        .post("rest-api/system/app/user/getInfo")
        .then((res) => {
          that.userInfo = res.data.user;
          this.filteredMenus = res.data.menus;
          // if (res.data.permissions && res.data.permissions.length > 0) {
          //   if (res.data.permissions[0] == "*:*:*") {
          //     // 过滤菜单
          //     this.filteredMenus = this.rawMenus;
          //   } else {
          //     // 设置用户权限
          //     initPermissions(res.data.permissions);
          //     // 过滤菜单
          //     this.filteredMenus = filterMenus(this.rawMenus);
          //   }
          // }
        })
        .catch((err) => {});
    },
    toggleUserDrop() {
      this.userDropShow = !this.userDropShow;
    },
    toggleSearchBox() {
      this.searchBox = !this.searchBox;
    },
    openPopBox(action = "login") {
      this.$refs.userLogin && this.$refs.userLogin.open(action);
    },
    exit() {
      // 清除Token
      localStorage.removeItem("Authorization");
      // 清除存储用户信息
      localStorage.removeItem("member");
      localStorage.removeItem("admin");
      // 修改store
      this.changeState({
        member: {},
        admin: {},
      });
      this.$message.success({
        message: "退出成功！",
        type: "success",
      });
      this.$router.push("/index");
    },
    search() {
      if (!this.keyword.trim()) {
        this.$message({
          message: "请输入关键词",
          type: "warning",
        });
        return;
      }

      // 检查是否已登录
      if (!this.isLoggedIn) {
        this.$message.warning("请先登录后再进行搜索");
        // 打开登录弹窗
        this.openPopBox("login");
        return;
      }

      const searchParams = {
        keyword: this.keyword,
        category: this.searchSelect,
      };

      this.goToPage("/search", searchParams);
    },
    setHeaderStyle(isScroll, isHover) {
      const headerEl = this.$refs.header;
      if (!headerEl) return;
      if (this.isDark) {
        headerEl.classList.remove("light-style");
        headerEl.classList.add("dark-style");
      } else if (isHover || isScroll) {
        headerEl.classList.remove("light-style");
        headerEl.classList.add("dark-style");
      } else {
        headerEl.classList.remove("dark-style");
        headerEl.classList.add("light-style");
      }
    },
    onScroll() {
      const docScroll =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      if (Math.abs(docScroll - this.lastScrollTop) > this.scrollThreshold) {
        if (docScroll > this.lastScrollTop) {
          this.scrollDirection = "down";
          this.$refs.header && this.$refs.header.classList.add("up");
        } else {
          this.scrollDirection = "up";
          this.$refs.header && this.$refs.header.classList.remove("up");
        }
        this.lastScrollTop = docScroll;
      }
      this.setHeaderStyle(docScroll > 0, false);
    },
    onMouseEnter() {
      if (this.isDark) return;
      this.setHeaderStyle(false, true);
    },
    onMouseLeave() {
      if (this.isDark) return;
      const docScroll =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      this.setHeaderStyle(docScroll > 0, false);
    },
    toggleWapMenu() {
      const nav = this.$refs.topNav;
      const openMenu = this.$refs.openMenu;
      if (!nav) return;
      nav.classList.toggle("menu-show");
      openMenu.classList.toggle("active");
    },
    closeWapMenu() {
      const nav = this.$refs.topNav;
      const openMenu = this.$refs.openMenu;
      if (!nav) return;
      nav.classList.remove("menu-show");
      openMenu && openMenu.classList.remove("active");
    },
    onDocumentClick(event) {
      const nav = this.$refs.topNav;
      const openMenu = this.$refs.openMenu;
      if (!nav) return;
      const target = event.target;
      // 如果点击发生在 top-nav 或 openMenu 内部，则不处理
      if (
        (nav && nav.contains(target)) ||
        (openMenu && openMenu.contains(target))
      ) {
        return;
      }
      // 其它区域点击，移除样式
      this.closeWapMenu();
    },

    filterMenus() {
      this.filteredMenus = PermissionUtils.filterMenus(this.menus);
    },

    // 判断单个菜单是否显示
    shouldShowMenu(menu) {
      // 优先级1：isShow 属性
      if (menu.isShow !== undefined) {
        return menu.isShow;
      }

      // 优先级2：检查权限
      if (menu.id) {
        return PermissionUtils.hasPermission(menu.id);
      }

      // 默认显示
      return true;
    },
  },
  computed: {
    // 导航当前样式
    current: function () {
      return function (outLink, children) {
        let res = false;
        const that = this;
        const currentUrl = that.$route.path;
        const matches = (link) =>
          link &&
          (link.indexOf("/content/") === 0
            ? currentUrl === link
            : currentUrl.indexOf(link) >= 0);

        // 检查直接匹配
        if (matches(outLink)) {
          res = true;
        }
        // 特殊处理：产品详情页应该匹配产品列表菜单
        else if (
          currentUrl === "/productDetails" &&
          outLink === "/productList"
        ) {
          res = true;
        }
        // 检查子菜单
        else {
          if (children && children.length > 0) {
            res = isCurrentUrlInMenu(currentUrl, children);
          }
        }

        function isCurrentUrlInMenu(currentUrl, menuArray) {
          for (const menuItem of menuArray) {
            // 直接匹配
            if (matches(menuItem.outLink)) {
              return true;
            }
            // 特殊处理：产品详情页应该匹配产品列表菜单
            if (
              currentUrl === "/productDetails" &&
              menuItem.outLink === "/productList"
            ) {
              return true;
            }
            // 递归检查子菜单
            if (menuItem.children && menuItem.children.length > 0) {
              const isChildMatch = isCurrentUrlInMenu(
                currentUrl,
                menuItem.children,
              );
              if (isChildMatch) {
                return true;
              }
            }
          }
          return false;
        }
        return res;
      };
    },
  },
};
</script>
<style lang="scss">
.nav-title {
  font-size: 20px;
}
.nav-item-title {
  font-size: 16px;
}
.input-with-select {
  border-radius: 0.2rem;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;

  .el-input-group__prepend {
    background-color: rgba(0, 0, 0, 0.1);
    border: 0;
    border-radius: 0;
    flex-shrink: 0;
    width: 1rem;
    padding: 0;

    .el-select {
      margin: 0;
      display: block;
    }
  }

  .el-input__inner {
    border: 0;
    color: #fff !important;
    font-size: 0.14rem;
    background-color: transparent;
    height: 0.4rem;
    line-height: 0.4rem;
    padding: 0 0.2rem;

    &::placeholder {
      color: rgba(255, 255, 255, 0.4);
    }
  }

  & > .el-input__inner {
    flex: 1;
  }

  .el-select {
    .el-input__inner {
      padding: 0 0.3rem 0 0.2rem;
    }

    .el-input {
      .el-select__caret {
        color: #fff;
        font-size: 0.1rem;
      }
    }
  }

  .el-input__suffix {
    width: 0.16rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .el-input-group__append {
    background: none;
    border: 0;
    border-radius: 0;
    padding: 0;
    display: flex;
    align-items: center;
    width: 0.36rem;
    flex-shrink: 0;

    .el-button {
      background: none;
      padding: 0;
      margin: 0;
      color: #fff;
    }
  }
}

@media (min-width: 1025px) {
  .dark-style {
    &:not(.header-member) {
      .input-with-select {
        background-color: #f7f7f7;

        .el-input-group__prepend {
          background-color: #ededed;
        }

        .el-input__inner {
          color: #333 !important;

          &::placeholder {
            color: rgba(153, 153, 153, 0.7);
          }
        }

        .el-select {
          .el-input {
            .el-select__caret {
              color: #999;
            }
          }
        }

        .el-input-group__append {
          .el-button {
            color: #999;
          }
        }
      }
    }
  }
}

@media (max-width: 1024px) {
  header {
    &:not(.header-member) {
      .input-with-select {
        background-color: #f7f7f7;

        .el-input-group__prepend {
          background-color: #ededed;
        }

        .el-input__inner {
          color: #333 !important;

          &::placeholder {
            color: rgba(153, 153, 153, 0.7);
          }
        }

        .el-select .el-input .el-select__caret,
        .el-input-group__append .el-button {
          color: #999;
        }
      }
    }
  }
}
.nav-listStyle-menu,
.nav-item2 {
  overflow: hidden;
  height: 0;
  transition: all 0.3s ease-in-out;
  &.show {
    height: auto;
  }
}
</style>
